import { useDispatch, useSelector } from 'react-redux';
import { useBroadcastChannel } from 'hooks';
import {
  WS_NEW_NOTIFY,
  WS_CLEAR_NOTIFY,
  NOTIFICATION_CHANNEL,
  SYNC_NOTIFICATION_CLEAR,
  SYNC_NOTIFICATION_CLEAR_ALL,
} from 'constants';
import store from '@control-front-end/app/src/store';

function useNotificationSync() {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);

  const handleBroadcastMessage = ({ type, payload }) => {
    if (type === SYNC_NOTIFICATION_CLEAR) {
      const { actorId, userId } = payload;
      if (userId !== auth.id) return;

      const notifyList = store.getState().wsNotify;
      const filterNotify = notifyList.filter((i) => i.actorId !== actorId);
      dispatch({ type: WS_NEW_NOTIFY, payload: filterNotify });
    } else if (type === SYNC_NOTIFICATION_CLEAR_ALL) {
      const { userId } = payload;
      if (userId !== auth.id) return;
      dispatch({ type: WS_CLEAR_NOTIFY });
    }
  };

  const sendBroadcastMessage = useBroadcastChannel(
    NOTIFICATION_CHANNEL,
    handleBroadcastMessage
  );

  return {
    syncClearNotification: (actorId) => {
      sendBroadcastMessage({
        type: SYNC_NOTIFICATION_CLEAR,
        payload: { actorId, userId: auth.id },
      });
    },
    syncClearAllNotifications: () => {
      sendBroadcastMessage({
        type: SYNC_NOTIFICATION_CLEAR_ALL,
        payload: { userId: auth.id },
      });
    },
  };
}

export default useNotificationSync;
